module.exports = __webpack_public_path__ + "img/zhuti-07.baacf3c8.png";